import { AdvancedSybilCheckResponse } from '../../types/rewards';

export const pushWalletSybilCheckModel = (response: AdvancedSybilCheckResponse): AdvancedSybilCheckResponse => response;
